import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
//import logo from '../../../assets/img/illustrations/falcon.png';
import logo from '../../../assets/img/illustrations/new_armory_white_logo.png';

// FetchWeapons

const Logo = ({ at, width, className, ...rest }) => {
  return (
    <Link
      to="/dashboard"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center font-weight-extra-bold fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        {/* <img className="mr-2" src={logo} alt="Logo" width={width} style={{ marginLeft: '-20px' }} /> */}
        <img className="mr-2" src={logo} alt="Logo" width="200px" style={{ marginLeft: '-5px' }} />
        {/* <span className="text-sans-serif" style={{ fontSize: '22px' }}>
          FetchWeapons
        </span> */}
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
